import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0f97e7e8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "personal-info-edit"
};
const _hoisted_2 = {
  class: "personal-info-edit-content"
};
import { CellCard, NavBar, MainButton } from '@/components';
import { ref, computed, getCurrentInstance, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { editUserInfoApi } from '@/api/personalInfo';
import { showToast } from "vant";
export default /*#__PURE__*/_defineComponent({
  __name: 'PersonalInfoEdit',
  setup(__props) {
    var _getCurrentInstance;
    const {
      $alert,
      $loading
    } = (_getCurrentInstance = getCurrentInstance()) === null || _getCurrentInstance === void 0 ? void 0 : _getCurrentInstance.proxy;
    const route = useRoute();
    const router = useRouter();
    const infoTypeMap = {
      mobile: '联系电话',
      email: '电子邮箱',
      fixPhone: '固定电话'
    };
    const infoType = ref('');
    // const infoValue = ref('')
    const inputValue = ref('');
    const typeText = computed(() => {
      return infoType.value ? infoTypeMap[infoType.value] : '';
    });
    const saveInfo = async () => {
      if (!inputValue.value) {
        showToast({
          message: `请输入${typeText.value}`
        });
        return;
      }
      if (typeText.value === '固定电话') {
        console.info('固定电话');
        const reg = /^(\d{3,4}-)?\d{7,8}$/;
        const reg400 = /^400[0-9]{7}/;
        const reg800 = /^800[0-9]{7}/;
        if (inputValue.value !== '' && (reg.test(inputValue.value) || reg400.test(inputValue.value) || reg800.test(inputValue.value))) {
          console.info('固定电话校验正确');
        } else {
          showToast({
            message: '您输入的固定电话格式有误'
          });
          return;
        }
      } else if (typeText.value === '电子邮箱') {
        const reg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
        if (inputValue.value !== '' && reg.test(inputValue.value)) {
          console.info('电子邮箱校验正确');
        } else {
          showToast({
            message: '您输入的电子邮箱格式有误'
          });
          return;
        }
      }
      // else if (typeText.value === '联系电话') {
      //     const reg = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/
      //     if (inputValue.value !== '' && reg.test(inputValue.value)) {
      //         console.info('联系电话校验正确')
      //     } else {
      //         showToast({
      //             message: '您输入的联系电话格式有误',
      //         })
      //         return
      //     }
      // }
      try {
        const param = {};
        param[infoType.value] = inputValue.value;
        $loading.openLoading();
        const {
          code,
          message,
          data
        } = await editUserInfoApi(param);
        $loading.closeLoading();
        if (code !== 9000) {
          $alert({
            message
          });
          return;
        }
        router.go(-1);
      } catch (error) {
        console.error(error);
      }
    };
    onMounted(() => {
      infoType.value = route.query.type;
      inputValue.value = route.query.infoValue;
      console.info('infoValue.value', inputValue.value);
    });
    return (_ctx, _cache) => {
      const _component_van_field = _resolveComponent("van-field");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(NavBar), {
        title: `输入${_unref(typeText)}`
      }, null, 8, ["title"]), _createElementVNode("div", _hoisted_2, [_createVNode(_unref(CellCard), null, {
        default: _withCtx(() => [_createVNode(_component_van_field, {
          class: "input",
          modelValue: inputValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => inputValue.value = $event),
          placeholder: `请输入${_unref(typeText)}`
        }, null, 8, ["modelValue", "placeholder"]), _createVNode(_unref(MainButton), {
          class: "btn",
          onClick: saveInfo
        }, {
          default: _withCtx(() => [_createTextVNode("保 存")]),
          _: 1
        })]),
        _: 1
      })])]);
    };
  }
});